<div
  fxLayout
  fxLayoutAlign="start center"
  fxLayoutGap="18px"
  class="lock-row"
  [class.unsupported]="!lock.is_supported"
  [matTooltipDisabled]="lock.is_supported"
  [matTooltip]="lock.unsupported_message">
  <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
    <div fxLayout="column" fxLayoutGap="6px">
      <strong>{{ lock.display_name }}</strong>
      <sbnb-cs-debug-item
        label="serial_number"
        [value]="lock.serial_number"
        style="font-size: 10px"></sbnb-cs-debug-item>
    </div>
  </div>

  <div
    fxFlex
    fxLayout
    fxLayoutAlign="start center"
    fxLayoutGap="12px"
    *ngIf="lock.integration_id == 'c1f4ea9e-6ade-4ce6-bfee-5545b5238197'">
    <div fxLayout="column" fxLayoutGap="6px">
      <strong>{{ lock.serial_number }}</strong>
    </div>
  </div>

  <sbnb-button
    *ngIf="lock.is_supported"
    label="Edit"
    size="mini"
    type="secondary"
    (click)="editLockEvent()"></sbnb-button>
</div>
